import { render } from "./CourseTheory.vue?vue&type=template&id=44c00d96"
import script from "./CourseTheory.vue?vue&type=script&lang=js"
export * from "./CourseTheory.vue?vue&type=script&lang=js"

import "./CourseTheory.vue?vue&type=style&index=0&id=44c00d96&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__